import React from 'react';
import { Popover, Whisper } from 'rsuite';

export function InfoPoint ({ placement, content, children }) {
    return (
        <Whisper
            trigger="click"
            placement={placement}
            controlId={`control-id-${placement}`}
            speaker={(
                <Popover>
                    {content}
                </Popover>
            )}
        >
            {children || placement}
        </Whisper>
    );
};
